/**
 * Route definition for /chains/xdc
 *
 * Renders the shared ChainPage with the `xdc` article. Chain facts live in
 * `@/data/chains`; presentation and SEO live in `@/components/ChainPage`.
 *
 * @module routes/chains/xdc
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import ChainPage from '@/components/ChainPage'

export const Route = createFileRoute('/$locale/chains/xdc')({
  component: function XdcChainPage() {
    return <ChainPage slug="xdc" />
  },
})
